export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/af.eeed8e82.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};